import API from "../utility/axios";
const apiUrl = '/api/v1';

export const UPLOAD_QUESTIONS = (data: any): Promise<any> => {
    return API.post(`${apiUrl}/cas/quetion/upload`, data);
}


